import {
  buildContactIdLookupHooks,
  buildStateValidationHook,
  buildZipValidationHook,
  mapCustomFieldsToDromoFields
} from 'bundles/crm/imports/helpers';
import { getPropertyFields } from './fields';

import type { CustomField } from 'bundles/apex/custom_fields/types';
import type { Country } from '../types';

export const groupId = 'crm_properties';

const ownerHooks = [
  buildContactIdLookupHooks(
    'Owner Contact ID',
    { idKey: 'ownerContactId', queryKey: 'ownerContact' },
  ),
  ...[2, 3, 4, 5, 6].map(i => buildContactIdLookupHooks(
    `Owner Contact ID ${i}`,
    { idKey: `ownerContactId${i}`, queryKey: `ownerContact${i}` },
  )),
];

export function getDromoImporterConfig(countries: Country[], customFields: CustomField[]) {
  return {
    bulkRowHooks: [
      ...ownerHooks.map(fieldHooks => fieldHooks.bulkRowHook),
      buildStateValidationHook(countries),
      buildZipValidationHook(),
    ],
    fields: [...getPropertyFields(countries), ...mapCustomFieldsToDromoFields(customFields)],
    groupId,
    importerOptions: {
      parser: 'Backoffice::Importer::Providers::Dromo::Parsers::Properties',
    },
    importerType: 'crm',
    stepHooks: ownerHooks.map(fieldHooks => fieldHooks.stepHook),
    title: 'Properties',
  };
}
